import axios, { AxiosResponse } from 'axios';
import { GetHasCreatorProductOnCartParams } from '@services/MarppleShop/features/Cart/repositories/params';
import { GetHasCreatorProductOnCartResult } from '@services/MarppleShop/features/Cart/repositories/results';

export const getHasCreatorProductOnCart = async ({
  store_id,
  user_id,
}: GetHasCreatorProductOnCartParams): Promise<GetHasCreatorProductOnCartResult> => {
  const { data } = await axios.get<string, AxiosResponse<GetHasCreatorProductOnCartResult>>(
    '/@api/cart/on_cart',
    {
      params: {
        store_id,
        user_id,
      },
    },
  );

  return data;
};
